import styled from "styled-components";

export const EditableTextWrapper = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
`;
